<template>
  <b-sidebar
    id="operation-modal"
    v-model="sidebar"
    bg-variant="white"
    no-close-on-backdrop
    right
    backdrop
    shadow
    width="680px"
    @hidden="$emit('update:isShowModal', false)"
    @shown="showModal"
  >
    <template #header="{ hide }">
      <feather-icon icon="XIcon" class="mt-1" @click="hide" />
      <h6 class="mb-0 mt-1 ml-2">
        {{ $t("finance.income") }}
      </h6>
    </template>
    <validation-observer ref="infoOperation">
      <b-overlay :show="finance_loading" opacity="0.6" rounded="lg">
        <b-row class="px-2">
          <!-- <b-col md="12">
            <b-tabs
              card
              class="pb-1"
              :active="type == 'income'"
            >
              <b-tab
                title-link-class=""
                @click="typeChange('income')"
              >
                <template #title>
                  <feather-icon icon="ArrowDownIcon" />
                  <span>{{ $t('finance.income') }}</span>
                </template>
              </b-tab>
              <b-tab
                title-link-class=""
                :active="type == 'expense'"
                @click="typeChange('expense')"
              >
                <template #title>
                  <feather-icon icon="ArrowUpIcon" />
                  <span>Выплата</span>
                </template>
              </b-tab>
            </b-tabs>
          </b-col> -->

          <b-col md="12" class="mt-2">
            <b-row class="align-items-center pb-1">
              <b-col md="4">
                <span>{{ $t("finance.date") }}</span>
              </b-col>
              <b-col md="8">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('finance.date')"
                  rules="required"
                >
                  <datepicker
                    v-model="date"
                    :name="$t('finance.date')"
                    format="dd.MM.yyyy"
                    :bootstrap-styling="true"
                    :clear-button="true"
                    :language="ru"
                    :calendar-button="true"
                    :placeholder="$t('finance.date')"
                    calendar-button-icon="fa fa-calendar"
                    clear-button-icon="fa fa-times"
                    input-class="bg-white"
                    @input="transaction.paid_at = customFormatter($event)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class="pb-1">
              <b-col md="4">
                <span>{{ $t("clients.contract") }}</span>
              </b-col>
              <b-col md="8">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('clients.contract')"
                  rules="required"
                >
                  <!-- <app-select
                    v-model="transaction.contract"
                    :state="transaction.contract"
                    :options="clientsList"
                    label="contract_number"
                    @fetch="fetchClientsList"
                  /> -->
                  <app-select
                    v-model="contract_value"
                    :options="GET_CONTRACTS_V2"
                    :item-selected.sync="contract_value"
                    :get-option-label="(item) => item.contract_number"
                    :lazy-fetch-data="FETCH_CONTRACTS"
                    :search="FETCH_CONTRACTS"
                    @input="onInputContract"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class="pb-1">
              <b-col md="4" />
              <b-col md="8">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('clients.contract')"
                  rules="required"
                >
                  <!-- <app-select
                    v-model="transaction.contract"
                    :options="GET_CONTRACTS_V2"
                    :item-selected.sync="transaction.contract"
                    :get-option-label="item => item.customer.name"
                    :lazy-fetch-data="FETCH_CONTRACTS"
                    :search="FETCH_CONTRACTS"
                    :reduce="opt => opt.id"
                  /> -->
                  <b-form-input v-model="client_name" readonly />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>

            <!-- <b-row class="pb-1">
              <b-col md="4">
                <span>{{ $t('finance.cash_box') }}</span>
              </b-col>
              <b-col md="8">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('finance.cash_box')"
                  rules="required"
                >
                  <v-select
                    v-model="transaction.income_cashbox"
                    :options="getTransactionCashbox.results"
                    :reduce="cashbox => cashbox.id"
                    label="title"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row> -->

            <b-row class="pb-1">
              <b-col md="4">
                <span>{{ $t("finance.payment_type") }}</span>
              </b-col>
              <b-col md="8">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('finance.payment_type')"
                  rules="required"
                >
                  <v-select
                    v-model="transaction.payment_type"
                    :options="paymentTypeOptions"
                    :get-option-label="(type) => type.title[$i18n.locale]"
                    :reduce="(type) => type.value"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class="pb-1">
              <b-col md="4">
                <span>{{ $t("finance.income_type") }}</span>
              </b-col>
              <b-col md="8">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('finance.income_type')"
                  rules="required"
                >
                  <v-select
                    v-model="transaction.income_type"
                    :options="income_type_options"
                    :get-option-label="(type) => type.title[$i18n.locale]"
                    :reduce="(type) => type.value"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>

            <!-- <b-row class="pb-1">
              <b-col md="4">
                <span>{{ $t('finance.cost') }}</span>
              </b-col>
              <b-col md="8">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('finance.cost')"
                  rules="required"
                >
                  <v-select
                    v-model="transaction.cost_item"
                    :reduce="income => income.id"
                    :options="transactionIncomeTypes"
                    label="name"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row> -->

            <!-- <b-row class="pb-1">
              <b-col md="4">
                <span>{{ $t('finance.personal_account') }}</span>
              </b-col>
              <b-col md="8">
                <app-select
                  v-model="transaction.account_number"
                  :state="transaction.account_number"
                  :options="account_numbers"
                  label="account_number"
                  @fetch="fetchClientsList"
                />
              </b-col>
            </b-row> -->

            <b-row class="pb-1">
              <b-col md="4">
                <span>{{ $t("finance.summ") }}</span>
              </b-col>
              <b-col md="8">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('finance.summ')"
                  rules="required"
                >
                  <cleave
                    id="number"
                    v-model="transaction.amount"
                    class="form-control"
                    :raw="true"
                    :options="options"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>
            <!-- <b-row class="pb-1">
              <b-col md="4">
                <span>Номер контракта</span>
              </b-col>
              <b-col md="8">
                <v-select
                  v-model="transaction.product"
                  :options="[]"
                  :reduce="graph => graph.id"
                  label="text"
                />
              </b-col>
            </b-row> -->
            <!-- :options="GET_ORDERS_GRAPH.results || []" -->

            <b-row class="pb-1">
              <b-col md="4">
                <span class="pt-1">{{ $t("finance.description") }}</span>
              </b-col>
              <b-col md="8">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('finance.description')"
                >
                  <b-form-textarea v-model="transaction.description" rows="2" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12" class="pt-2 d-flex justify-content-end">
                <b-button variant="secondary" class="mr-1" @click="close">
                  {{ $t("generals.cancel") }}
                </b-button>
                <b-button variant="success" @click="onSubmit">
                  {{ $t("generals.save") }}
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-overlay>
    </validation-observer>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BRow,
  BCol,
  // BTab,
  // BTabs,
  // BFormGroup,
  // BFormCheckbox,
  // BFormInput,
  BFormInput,
  BFormTextarea,
  BButton,
  BOverlay,
} from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "@validations";
import vSelect from "vue-select";
import Cleave from "vue-cleave-component";
import Datepicker from "vuejs-datepicker";
import { ru } from "vuejs-datepicker/dist/locale";
// import moment from 'moment'
import AppSelect from "@/components/AppSelect.vue";
import useJwt from "@/auth/jwt/useJwt";

export default {
  components: {
    BSidebar,
    BRow,
    BCol,
    // BTab,
    // BTabs,
    BFormTextarea,
    BButton,
    BFormInput,
    ValidationObserver,
    ValidationProvider,
    vSelect,
    Cleave,
    Datepicker,
    BOverlay,
    AppSelect,
  },
  props: {
    isShowModal: {
      type: Boolean,
      default: false,
    },
    operation: {
      type: Object,
      default: () => ({}),
    },
    admission: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      contact: null,
      date: null,
      finance_loading: false,
      account_numbers: {
        count: 0,
        results: [],
      },
      ru,
      client_out: null,
      clientsList: {
        results: [],
      },
      required,
      sidebar: false,
      type: "income",
      income_type_options: [
        {
          title: {
            ru: "Продажа",
            uz: "Sotuv",
          },
          value: "sale",
        },
        {
          title: {
            ru: "Дебитор",
            uz: "Debitor",
          },
          value: "debtor",
        },
      ],
      client_name: "",
      payment_type_options: [
        {
          title: {
            ru: "Банк",
            uz: "Bank",
          },
          value: "cash",
          key: "is_bank",
        },
        {
          title: {
            ru: "Наличные",
            uz: "Naqd",
          },
          value: "noncash",
          key: "is_cash",
        },
        {
          title: {
            ru: "Бартер",
            uz: "Barter",
          },
          value: "barter",
          key: "is_barter",
        },
      ],
      contract_value: null,
      transaction: {
        id: null,
        type: "",
        paid_at: "",
        contract: "",
        income_cashbox: null,
        cost_item: 1,
        amount: "",
        description: "",
      },
      transactionIncomeTypes: [],
      options: {
        numeral: true,
        numeralThousandsGroupStyle: "thousand",
      },
    };
  },
  watch: {
    isShowModal(val) {
      this.sidebar = val;
    },
    type(newValue) {
      this.filterIncomeTypes(newValue);
    },
    operation(newValue) {
      if (newValue) {
        const {
          id,
          amount,
          income_cashbox,
          contract,
          cost_item,
          paid_at,
          description,
          product,
          type,
        } = newValue;

        this.type = type;
        this.clientsList.results = this.clientsList.results.filter(
          (c) => c.id !== contract.id,
        );
        this.clientsList.results.push(contract);
        this.client_out = contract.id;

        this.transaction = {
          id,
          contract: contract.id,
          paid_at,
          income_cashbox: income_cashbox.id,
          description,
          cost_item: cost_item.id,
          amount,
          product,
        };
      } else {
        this.clearData();
        this.$nextTick(() => {
          this.$refs.infoOperation.reset();
        });
      }
    },
  },
  // eslint-disable-next-line vue/order-in-components
  computed: {
    // ...mapGetters('contract', ['GET_ORDERS_GRAPH']),
    ...mapGetters("contracts", ["GET_CONTRACTS", "GET_CONTRACTS_V2"]),
    ...mapGetters("finance", [
      "GET_TRANSACTIONS",
      "getTransactionIncomeType",
      "getTransactionCashbox",
    ]),

    paymentTypeOptions() {
      return this.payment_type_options.filter((option) => {
        return useJwt.getUserData()[option.key]?.includes(true);
      });
    },
  },
  async mounted() {
    const query = {
      page_size: 10,
      page: 1,
    };
    this.FETCH_TRANSACTION_CASHBOX(query);
    this.filterIncomeTypes("income");
  },
  methods: {
    ...mapActions("contracts", ["FETCH_CONTRACTS"]),
    // ...mapActions('contract', ['FETCH_ORDERS_GRAPH']),
    ...mapActions("finance", [
      "ADD_TRANSACTIONS",
      // 'FETCH_TRANSACTION_INCOME_TYPE',
      "FETCH_TRANSACTION_CASHBOX",
      "UPDATE_TRANSACTIONS",
    ]),
    async fetchClientsList() {
      const res = await this.FETCH_CONTRACTS();
      console.log("res", res);
      this.clientsList = {
        count: res.count,
        results: res.results,
      };
    },
    onInputContract(item) {
      if (item) {
        this.client_name = item.customer.name;
        this.transaction.contract = item.id;
      } else {
        this.client_name = null;
        this.transaction.contract = null;
      }
    },
    onSubmit() {
      this.$refs.infoOperation.validate().then(async (success) => {
        if (!success) {
          return;
        }
        try {
          this.transaction.type = this.type;
          if (this.operation) {
            await this.UPDATE_TRANSACTIONS(this.transaction);
            this.$emit("updated");
            this.sidebar = false;
            this.$refs.infoOperation.reset();
            this.$_successToast(this.$t("generals.changed"));
            return;
          }
          // console.log('adfqdfwqdq', this.transaction)
          this.finance_loading = true;
          await this.ADD_TRANSACTIONS(this.transaction);
          this.finance_loading = false;
          this.$emit("updated");
          this.sidebar = false;
          this.$refs.infoOperation.reset();
          this.$_successToast(this.$t("generals.added"));

          // setTimeout(() => {
          //   this.clearData()
          //   this.$nextTick(() => {
          //     this.$refs.infoOperation.reset()
          //   })
          // }, 1000)
        } catch (err) {
          this.finance_loading = false;
          this.$_errorToast(this.$t("generals.error"));
        }
      });
    },
    typeChange(type) {
      // this.transaction.cost_item = null
      this.transaction.type = type;
    },
    filterIncomeTypes(type) {
      this.transactionIncomeTypes = this.getTransactionIncomeType.results
        .filter((item) => item.type === type)
        .map((item) => ({
          ...item,
          title: item.name.ru,
        }));
    },
    close() {
      this.sidebar = false;
      this.$nextTick(() => {
        this.$refs.infoOperation.reset();
      });
    },
    clearData() {
      this.type = "income";
      this.client_name = null;
      this.contract_value = null;
      this.transaction = {
        client: null,
        paid_at: "",
        contract: "",
        income_cashbox: null,
        description: "",
        cost_item: null,
        amount: "",
      };
    },

    customFormatter(date) {
      if (date) {
        // return moment(date).format('YYYY-MM-DD')
        // console.log()
        return new Date(date).toISOString().split("T")[0];
      }
      return null;
    },
    showModal() {
      if (this.operation) {
        this.date = this.operation.paid_at;
        this.transaction = {
          id: this.operation.id,
          paid_at: this.operation.paid_at,
          contract: this.operation.contract,
          income_cashbox: this.operation.income_cashbox.id,
          cost_item: this.operation.cost_item.id,
          amount: this.operation.amount,
          description: this.operation.description,
        };
      } else {
        this.date = null;
        this.client_name = null;
        this.contract_value = null;
        this.transaction = {
          // id: null,
          paid_at: "",
          contract: "",
          income_cashbox: null,
          cost_item: 1,
          amount: "",
          description: "",
        };
      }
    },
  },
};
</script>
